(() => {
  'use strict';
  const ready = new WeakSet();
  const storageKey = 'u4wd-rig-guide-v2';
  const parse = (element, fallback) => { try { return JSON.parse(element?.textContent || ''); } catch { return fallback; } };
  const labels = () => parse(document.getElementById('U4GuidanceCopy'), {});
  const catalogue = () => parse(document.getElementById('U4Catalog'), { products: [] });
  const make = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const variantUrl = (product, variant) => {
    const url = new URL(product.url, location.origin);
    url.searchParams.set('variant', variant.id);
    return url.pathname + url.search;
  };
  const session = () => { try { const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); return value?.version === 2 ? value : null; } catch { return null; } };
  const startQuiz = (host) => {
    if (ready.has(host) || !window.U4Setup) return;
    const data = catalogue();
    if (!data.products.length) return;
    const copy = labels();
    if (!copy.next || !copy.finish || !copy.fitment_unknown) return;
    ready.add(host);
    const form = host.querySelector('[data-u4-rig-form]');
    form.noValidate = true;
    const steps = [...form.querySelectorAll('[data-u4-step]')];
    const plan = host.querySelector('[data-u4-plan]');
    const next = host.querySelector('[data-u4-next]');
    const previous = host.querySelector('[data-u4-prev]');
    const progress = [...host.querySelectorAll('.u4-step-progress li')];
    const routeMap = parse(host.querySelector('[data-u4-route-map]'), window.U4Setup.jobs);
    let step = 0, showingResults = false;
    const answers = () => {
      const fields = new FormData(form);
      return window.U4Setup.clean({ ...Object.fromEntries(fields), parts: fields.getAll('parts') });
    };
    const save = () => {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ version: 2, step, showResults: showingResults, answers: answers() })); }
      catch { host.querySelector('[data-u4-save-status]').textContent = copy.storage_failed; }
    };
    const branch = (restoredMount) => {
      const job = form.querySelector('[name="job"]:checked')?.value || '';
      const conditions = { front: job === 'front', camp: job === 'camp', vehicle: form.querySelector('[name="vehicle_known"]:checked')?.value === 'yes', measured: form.querySelector('[name="measured"]:checked')?.value === 'yes' };
      host.querySelectorAll('[data-u4-condition]').forEach(group => {
        group.hidden = !conditions[group.dataset.u4Condition];
        group.querySelectorAll('input,select').forEach(control => { control.disabled = group.hidden; });
      });
      const mount = form.querySelector('[data-u4-mount]');
      if (mount.dataset.job !== job) {
        const chosen = restoredMount || mount.value;
        const options = { front: ['bullbar', 'grille', 'roof'], fog: ['bullbar', 'grille'], work: ['rear', 'roof'], camp: ['awning', 'rear'], rock: ['underbody'] };
        mount.replaceChildren();
        ['unknown', ...(options[job] || []), 'other'].forEach(value => {
          const option = make('option', copy['mount_' + value]);
          option.value = value;
          mount.append(option);
        });
        mount.value = [...mount.options].some(option => option.value === chosen) ? chosen : 'unknown';
        mount.dataset.job = job;
      }
    };
    const showStep = (index, focus) => {
      step = Math.max(0, Math.min(steps.length - 1, index));
      showingResults = false;
      form.hidden = false; plan.hidden = true;
      steps.forEach((panel, item) => { panel.hidden = item !== step; });
      progress.forEach((item, position) => { if (position === step) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current'); });
      previous.hidden = step === 0;
      next.textContent = step === steps.length - 1 ? copy.finish : copy.next;
      if (focus) steps[step].querySelector('legend').focus({ preventScroll: false });
    };
    const briefText = (result) => {
      const input = result.answers;
      const vehicle = [input.make, input.model, input.year].filter(Boolean).join(' ') || copy.brief_undefined;
      const space = input.width || input.height ? (input.width || '?') + ' × ' + (input.height || '?') + ' mm' : copy.brief_undefined;
      return [copy.brief_title, copy.brief_job + ': ' + (copy['job_' + input.job] || copy.brief_undefined), copy.brief_vehicle + ': ' + vehicle, copy.brief_mount + ': ' + (copy['mount_' + input.mount] || copy.brief_undefined), copy.brief_space + ': ' + space, copy.brief_voltage + ': ' + (input.voltage === 'unknown' ? copy.brief_undefined : input.voltage), copy.brief_installation + ': ' + copy['installation_' + input.installation], copy.brief_parts + ': ' + (input.parts.map(value => copy['parts_' + value]).join(', ') || copy.brief_undefined), '', ...result.results.map(item => copy.brief_product + ': ' + item.product.title + ' · ' + item.variant.sku + ' · ' + item.variant.money + ' · ' + (item.product.unit || copy.unknown)), '', copy.fitment_unknown, copy.extras_note].join('\n');
    };
    const renderCard = (entry, result) => {
      const product = entry.product;
      let variant = entry.variant;
      const card = make('article', undefined, 'u4-plan-product');
      const head = make('div', undefined, 'u4-plan-product-head');
      if (product.image) { const image = make('img'); image.src = product.image; image.alt = ''; image.width = 160; image.height = 160; image.loading = 'lazy'; head.append(image); }
      const identity = make('div');
      const heading = make('h4'); const title = make('a', product.title); title.href = variantUrl(product, variant); heading.append(title);
      const facts = make('small', [product.beam, product.size, product.unit].filter(Boolean).join(' · '));
      identity.append(heading, facts); head.append(identity); card.append(head);
      const reasons = make('ul', undefined, 'u4-reason-list');
      entry.reasons.forEach(reason => reasons.append(make('li', copy[reason + '_reason'])));
      card.append(reasons);
      let select;
      const availableVariants = product.variants || [];
      if (availableVariants.length > 1) {
        const label = make('label', product.optionNames?.join(' / ') || copy.option);
        select = make('select'); select.setAttribute('aria-label', (product.optionNames?.join(' / ') || copy.option) + ' · ' + product.title);
        availableVariants.forEach(item => {
          const withinBudget = item.price <= result.budget;
          const option = make('option', item.title + ' · ' + item.money + (!item.available ? ' · ' + copy.unavailable : !withinBudget ? ' · ' + copy.over_budget_option : ''));
          option.value = item.id; option.disabled = !item.available || !withinBudget; option.selected = String(item.id) === String(variant.id); select.append(option);
        });
        label.append(select); card.append(label);
      }
      const price = make('p', variant.money, 'u4-plan-price');
      const priceNote = make('small', copy.known_price + ' · ' + (product.unit || copy.unknown));
      const sku = make('p', copy.sku + ': ' + (variant.sku || copy.unknown), 'u4-caption');
      const contents = make('p', product.harness === true ? copy.listed_harness : copy.unknown_harness, 'u4-plan-included');
      const actions = make('div', undefined, 'u4-button-row');
      const link = make('a', copy.view_product + ' ↗', 'u4-button'); link.href = variantUrl(product, variant);
      const compare = make('button', copy.compare_product, 'u4-compare-button'); compare.type = 'button'; compare.dataset.u4Compare = JSON.stringify({ id: product.id, title: product.title, url: product.url, variantId: variant.id }); compare.setAttribute('aria-pressed', 'false');
      actions.append(link, compare); card.append(price, priceNote, sku, contents, actions);
      if (select) select.addEventListener('change', () => {
        const selected = availableVariants.find(item => String(item.id) === select.value);
        if (!selected?.available || selected.price > result.budget) return;
        variant = selected; entry.variant = selected;
        price.textContent = variant.money; sku.textContent = copy.sku + ': ' + (variant.sku || copy.unknown);
        title.href = link.href = variantUrl(product, variant);
        compare.dataset.u4Compare = JSON.stringify({ id: product.id, title: product.title, url: product.url, variantId: variant.id });
        host.querySelector('[data-u4-plan-brief]').value = briefText(result);
      });
      return card;
    };
    const renderResults = (focus) => {
      branch();
      const result = window.U4Setup.evaluate(data.products, answers(), routeMap);
      if (!result.answers.job) { showStep(0, focus); return; }
      showingResults = true; form.hidden = true; plan.hidden = false;
      progress.forEach(item => item.removeAttribute('aria-current'));
      host.querySelector('[data-u4-plan-status]').textContent = result.results.length === 1 ? copy.results_one : result.results.length ? copy.results_count.replace('{count}', result.results.length) : copy.no_match;
      const summary = host.querySelector('[data-u4-plan-summary]');
      summary.replaceChildren();
      if (result.results.length) summary.append(make('p', copy.conditional, 'u4-caution'));
      const input = result.answers;
      const selection = [copy['job_' + input.job], [input.make, input.model, input.year].filter(Boolean).join(' '), copy['mount_' + input.mount]].filter(Boolean).join(' · ');
      summary.append(make('p', selection, 'u4-caption'));
      summary.append(make('p', copy.extras_note, 'u4-caption'));
      const exclusions = [];
      if (result.excluded.unavailable) exclusions.push(copy.unavailable_count.replace('{count}', result.excluded.unavailable));
      if (result.excluded.overBudget) exclusions.push(copy.budget_count.replace('{count}', result.excluded.overBudget));
      if (result.excluded.differentLength) exclusions.push(copy.length_count.replace('{count}', result.excluded.differentLength));
      if (exclusions.length) summary.append(make('p', exclusions.join(' · '), 'u4-plan-exclusions'));
      const cards = host.querySelector('[data-u4-plan-products]'); cards.replaceChildren();
      result.results.forEach(entry => cards.append(renderCard(entry, result)));
      const checks = make('div', undefined, 'u4-plan-checks'); checks.append(make('h4', copy.requires_check));
      const list = make('ul');
      list.append(make('li', input.vehicle_known === 'unknown' || !input.make || !input.model ? copy.vehicle_unknown : copy.fitment_unknown));
      list.append(make('li', input.measured === 'yes' ? copy.measured_note.replace('{value}', (input.width || '?') + ' × ' + (input.height || '?') + ' mm') : copy.mount_check));
      list.append(make('li', input.voltage === 'unknown' ? copy.voltage_unknown : copy.power_check + ' (' + input.voltage + ')'));
      if (input.parts.includes('harness') || result.results.some(item => item.product.harness === true)) list.append(make('li', copy.avoid_duplicate));
      checks.append(list);
      if (input.parts.length) checks.append(make('p', copy.own_parts + ' ' + input.parts.map(value => copy['parts_' + value]).join(', '), 'u4-caption'));
      checks.append(make('p', copy.source_note, 'u4-caption'));
      host.querySelector('[data-u4-plan-checks]').replaceChildren(checks);
      host.querySelector('[data-u4-plan-brief]').value = briefText(result);
      save(); document.dispatchEvent(new CustomEvent('u4:comparison-refresh'));
      if (focus) {
        plan.focus({ preventScroll: true });
        (window.matchMedia('(min-width:990px)').matches ? host : plan).scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      const invalid = [...steps[step].querySelectorAll('input,select')].find(control => !control.disabled && !control.checkValidity());
      if (invalid) { invalid.reportValidity(); return; }
      if (step === steps.length - 1) renderResults(true);
      else { showStep(step + 1, true); save(); }
    });
    form.addEventListener('input', () => { branch(); save(); });
    form.addEventListener('change', () => { branch(); save(); });
    previous.addEventListener('click', () => { showStep(step - 1, true); save(); });
    host.querySelector('[data-u4-edit]').addEventListener('click', () => { showStep(0, true); save(); });
    host.querySelector('[data-u4-restart]').addEventListener('click', () => {
      form.reset(); showingResults = false; branch(); showStep(0, true);
      host.querySelector('[data-u4-plan-products]').replaceChildren();
      host.querySelector('[data-u4-plan-brief]').value = '';
      host.querySelector('[data-u4-copy-status]').textContent = '';
      try { sessionStorage.removeItem(storageKey); } catch { }
    });
    host.querySelector('[data-u4-copy-brief]').addEventListener('click', async () => {
      const area = host.querySelector('[data-u4-plan-brief]');
      try { await navigator.clipboard.writeText(area.value); host.querySelector('[data-u4-copy-status]').textContent = copy.copied; }
      catch { area.focus(); area.select(); host.querySelector('[data-u4-copy-status]').textContent = copy.copy_failed; }
    });
    const saved = session();
    if (saved?.answers) {
      const restored = window.U4Setup.clean(saved.answers);
      [...form.elements].forEach(control => {
        if (!(control.name in restored) || control.name === 'mount') return;
        if (control.type === 'checkbox') control.checked = restored.parts.includes(control.value);
        else if (control.type === 'radio') control.checked = restored[control.name] === control.value;
        else control.value = restored[control.name];
      });
      branch(restored.mount);
      showStep(Number(saved.step) || 0, false);
    } else { branch(); showStep(0, false); }
    host.querySelector('[data-u4-quiz-fallback]').hidden = true;
    host.querySelector('[data-u4-quiz-interactive]').hidden = false;
    host.classList.add('is-ready');
    if (saved?.showResults && saved.answers?.job) renderResults(false);
  };
  const bindTabs = (host, selector, panelSelector, onChange) => {
    if (ready.has(host)) return;
    ready.add(host);
    const tabs = [...host.querySelectorAll(selector)];
    const panels = [...host.querySelectorAll(panelSelector)];
    const activate = (tab, focus) => {
      tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      onChange(tab);
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', event => {
        let position;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') position = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') position = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') position = 0;
        if (event.key === 'End') position = tabs.length - 1;
        if (position === undefined) return;
        event.preventDefault(); activate(tabs[position], true);
      });
    });
    host.classList.add('is-ready');
    if (tabs[0]) activate(tabs[0], false);
  };
  const startKit = (host) => {
    if (ready.has(host)) return;
    ready.add(host);
    const product = catalogue().products.find(item => String(item.id) === host.dataset.productId);
    const main = document.querySelector('product-info[id^="MainProduct-"]');
    let lastVariant;
    const update = () => {
      const id = main?.querySelector('product-form input[name="id"]')?.value;
      if (!id || lastVariant === id) return;
      const variant = product?.variants.find(item => String(item.id) === id);
      if (!variant) return;
      lastVariant = id;
      const variantText = [variant.title === 'Default Title' ? '' : (product.optionNames?.join(' / ') || labels().option) + ': ' + variant.title, variant.sku].filter(Boolean).join(' · ');
      host.querySelectorAll('[data-u4-kit-variant]').forEach(node => { node.textContent = variantText; });
      host.querySelectorAll('[data-u4-kit-price]').forEach(node => { node.textContent = variant.money; });
      host.querySelectorAll('[data-u4-kit-option]').forEach(node => { node.textContent = variant.title; });
      [...main.querySelectorAll('[data-u4-compare]'), ...host.querySelectorAll('[data-u4-compare]')].forEach(button => {
        const current = parse({ textContent: button.dataset.u4Compare }, {});
        if (String(current.id) === String(product.id)) button.dataset.u4Compare = JSON.stringify({ id: product.id, title: product.title, url: product.url, variantId: variant.id });
      });
      document.dispatchEvent(new CustomEvent('u4:catalog-variant', { detail: { id: product.id, variantId: variant.id } }));
    };
    if (main) {
      main.addEventListener('change', event => {
        if (event.target.matches('product-form input[name="id"]')) update();
      });
      new MutationObserver(update).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled', 'aria-disabled'] });
    }
    update();
    if (session()?.showResults) host.querySelector('[data-u4-setup-context]').hidden = false;
  };
  const start = (root = document) => {
    root.querySelectorAll('[data-u4-quiz]').forEach(startQuiz);
    root.querySelectorAll('[data-u4-understand]').forEach(host => bindTabs(host, '[data-u4-learn]', '[data-u4-learn-panel]', tab => { host.querySelector('.u4-product-stage').dataset.stage = tab.dataset.u4Learn; }));
    root.querySelectorAll('[data-u4-beam-lab]').forEach(host => bindTabs(host, '[data-u4-beam]', '[data-u4-beam-panel]', tab => { host.querySelector('.u4-beam-stage').dataset.beam = tab.dataset.u4Beam; }));
    root.querySelectorAll('[data-u4-kit]').forEach(startKit);
  };
  document.addEventListener('shopify:section:load', event => start(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start()); else start();
})();
